import React, {Component} from 'react'
import DocumentTitle from "react-document-title"
import {Icon, Layout, Menu} from 'antd';
import {NavBar} from 'antd-mobile';

const { Content, Footer } = Layout;

class DefaultLayout extends Component {

    static defaultProps = {
        loading: false
    };

    constructor(props) {
        super(props);
        let collapsed = false;
        if(window.screen.width <= 1024) {
            collapsed = true;
        }
        this.state = {
            collapsed: collapsed,
            user: {},
            current: 'home'
        };
    }

    onClickLogout = () => {
        localStorage.setItem("urlBack", window.location.href);
        this.props.history.replace('/login');
    };

    handleClick = e => {
        this.setState({current: e.key});
        this.props.history.push('/'+e.key);
    };

    toggle = () => {
        this.setState({
            collapsed: !this.state.collapsed,
        });
    };

    render() {
        let content = this.props.children;
        let hiddenFt = this.props.hasOwnProperty('hiddenFt') && this.props.hiddenFt !== undefined ? this.props.hiddenFt : false;
        let lefContent = (() => this.props.history.goBack());
        if (this.props.backToHome){
            lefContent = (() => this.props.history.push('/'));
        }
        let rightContent = (<div></div>);
        if(this.props.showHome){
            rightContent = (<Icon type="home" onClick={() => this.props.history.push('/')} />);
        }
        if (this.props.showEditBtn){
            rightContent = (<Icon type="edit" onClick={() => this.props.history.push('/cap-nhat-thong-tin-xe?edit=1&id='+this.props.itemID)} />);
        }
        return (
            <DocumentTitle title={this.props.hasOwnProperty('title') && this.props.title !== undefined ? this.props.title : 'INSA'}>
                <Layout className={"main-layout"}>
                    <NavBar
                        mode="light"
                        icon={<Icon type="left" />}
                        onLeftClick={lefContent}
                        rightContent={[rightContent]}
                    >{this.props.title}</NavBar>
                    <Content className={"main-content "+this.props.classNameContent}>
                        {content}
                    </Content>
                    <Footer className="sticky-bottom" hidden={hiddenFt}>
                        <Menu onClick={this.handleClick} selectedKeys={[this.state.current]} mode="horizontal">
                            <Menu.Item key="home" className="ant-col-4">
                                <div className="itemMenu">
                                    <Icon type="home" />
                                </div>
                                <div className="itemMenu">Trang chủ</div>
                            </Menu.Item>
                            <Menu.Item key="mua-bao-hiem" className="ant-col-4">
                                <div className="itemMenu"><Icon type="shop" /></div>
                                <div className="itemMenu">Mua bảo hiểm</div>
                            </Menu.Item>
                            <Menu.Item key="support" className="ant-col-4">
                                <div className="itemMenu"><Icon type="question-circle" /></div>
                                <div className="itemMenu">Hỗ trợ</div>
                            </Menu.Item>
                            <Menu.Item key="user" className="ant-col-4">
                                <div className="itemMenu"><Icon type="user" /></div>
                                <div className="itemMenu">Cá nhân</div>
                            </Menu.Item>
                        </Menu>
                    </Footer>
                </Layout>
            </DocumentTitle>
        )
    }
}

export default DefaultLayout